"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('surfaceActionsOption', {
    readSurfaceActions: null,
    readSurfaceAddins: null,
    composeSurfaceActions: null,
    composeSurfaceAddins: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/store/store.js
// module id = 3084
// module chunks = 2